import React from 'react'
import PropTypes from 'prop-types'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

const SpreadsheetTable = ({ data = [] }) => (
    (data.length > 0) &&
    <BootstrapTable data={data} hover bordered>
        <TableHeaderColumn isKey dataField="row" width="40px" dataAlign="center">Row</TableHeaderColumn>
        <TableHeaderColumn dataField="agencyCode">Agency Code</TableHeaderColumn>
        <TableHeaderColumn dataField="email">Email</TableHeaderColumn>
    </BootstrapTable>
)

SpreadsheetTable.propTypes = {
    title: PropTypes.string.isRequired,
    eventKey: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            row: PropTypes.number,
            agencyCode: PropTypes.string,
            email: PropTypes.string,
        })
    ),
}

export default SpreadsheetTable
